import { InspectionDetailsResponse } from "../../api-models/response/inspection/InspectionDetailsResponse";
import { InspectionWithDates } from "../../api-models/response/SectionDetailsResponse";
import { Video } from "./Video";
import { NameEntityResponse } from "../../api-models/response/NameEntityResponse";
import { InspectionLockDetails } from "../../api-models/response/InspectionLockDetails";
import { BaseTechnicalInspection } from "../technical-inspection/BaseTechnicalInspection";
import { dateService } from "../date-service/DateService";

export const emptyInspection: InspectionDetailsResponse = {
  id: 0,
  sectionId: "",
  inspectionId: "",
  lock: null,
  project: undefined,
  created: new Date(),
  createdBy: { id: 0, name: "", isDeleted: false },
  dynamicProperties: [],
  video: undefined,
  inspectionNumber: 0,
  genericIssues: [],
  isRelevant: false,
  hasIpfFile: false,
};

export class InspectionDetails extends BaseTechnicalInspection {
  id: number;
  sectionId: string;
  inspectionId: string;
  lock: InspectionLockDetails;
  projectId?: number;
  projectName?: string | undefined;
  gatheringDate?: Date | undefined;
  created: Date;
  createdBy: NameEntityResponse;
  video?: Video | undefined;
  inspectionNumber: number;
  isRelevant: boolean;
  hasIpfFile: boolean;

  constructor(inspection: InspectionDetailsResponse) {
    super(inspection.dynamicProperties, inspection.genericIssues);
    this.id = inspection.id;
    this.sectionId = inspection.sectionId;
    this.inspectionId = inspection.inspectionId;
    this.lock = inspection.lock;
    this.projectId = inspection.project?.id;
    this.projectName = inspection.project?.name;
    this.created = inspection.created;
    this.createdBy = inspection.createdBy;
    this.video = !inspection.video ? undefined : new Video(inspection.video);
    this.inspectionNumber = inspection.inspectionNumber;
    this.gatheringDate = inspection.gatheringDate;
    this.genericIssues = inspection.genericIssues;
    this.isRelevant = inspection.isRelevant;
    this.hasIpfFile = inspection.hasIpfFile;
  }

  getName(inspections: InspectionWithDates[]) {
    if (!this.id || !inspections.length) return "";
    const inspectionWithDates = inspections.filter((inspection) => inspection.id === this.id)[0];
    const dateForDisplay = dateService.formatDate(this.gatheringDate || this.created);
    return `${inspectionWithDates.inspectionNumber} (${dateForDisplay})`;
  }

  getDate() {
    return dateService.formatDate(this.gatheringDate || this.created);
  }

  get hasNoVideoAssociated(): boolean {
    return !this.video;
  }

  get hasVideo(): boolean {
    return !!(this.video?.size && this.video?.url);
  }

  get videoURL(): string {
    if (!this.video) {
      return "";
    }
    return this.video.urlForHtml5 || this.video.url;
  }
}
